import { useEffect, useState, memo } from 'react';
import PropTypes                     from 'prop-types';
import { useTranslation }            from 'next-i18next';
import styles                        from './resend-code.module.scss';

import ReplayOutlinedIcon from '@material-ui/icons/ReplayOutlined';

const ResendCode = ({
  onResendCode,
  resendDelaySeconds
}) => {
  const { t } = useTranslation('common');
  const [seconds, setSeconds] = useState(resendDelaySeconds);

  // --------------------------------------------------------

  useEffect(() => {
    let timeout;

    if (seconds === 0) {
      clearTimeout(timeout);
    } else {
      timeout = setTimeout(() => {
        setSeconds(seconds => --seconds);
      }, 1000);
    }

    return () => {
      clearTimeout(timeout);
    }
  }, [seconds]);

  // --------------------------------------------------------

  const resend = async (scope) => {
    onResendCode()
    .then(() => {
      setSeconds(resendDelaySeconds)
    }).catch(err => console.log(err));
  };

  // --------------------------------------------------------

  return (
    <div className={styles.root}>
      <Choose>
        <When condition={seconds === 0}>
          <div
            className={styles.resend_link}
            onClick={(e) => { resend() }}
          >
            <ReplayOutlinedIcon />
            <span>Отправить e-mail с кодом</span>
          </div>
        </When>
        <Otherwise>
          <div className={styles.resend_info_time}>
            <ReplayOutlinedIcon />
            <span>Отправить e-mail с кодом повторно {seconds} {t('common.measures.seconds')}</span>
          </div>
        </Otherwise>
      </Choose>
    </div>
  )
};

ResendCode.propTypes = {
  onResendCode: PropTypes.func.isRequired,
  resendDelaySeconds: PropTypes.number
};

ResendCode.defaultProps = {
  resendDelaySeconds: 45
};

export default memo(ResendCode);